export default __webpack_public_path__ + "static/media/returnRigh.aed8e3ee.svg";